import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Messages } from "primereact/messages";
import { confirmDialog } from "primereact/confirmdialog";
import { Skeleton } from "primereact/skeleton";
// components
import Modal from "../../components/modal/Modal";
import Select from "../../components/input/Select";
import NumberInput from "../../components/input/NumberInput";
//services
import { getCommissionsById } from "../../services/Commissions/getCommissionsById";
import { patchCommissionsGeral } from "../../services/Commissions/patchCommissionsById";
import { patchCommissionsStatus } from "../../services/Commissions/patchCommissionsStatus";
//utils
import { formatCurrency } from "../../utils/formatCurrency";
import { formatDate } from "../../utils/formatDate";
//calculos
import {
  calcCommissionGeral,
  handleMultipliesCommission,
  calcPercentageImobWithoutBrokers,
  calcValueImobWithoutBrokers,
} from "./CommissionsCalculations/CommissionsCalculations";
import { useAppContext } from "../../context/AppContext";

export function LaunchCommissionSale() {
  const navigate = useNavigate();
  const form = useForm();
  const errors = form.formState.errors;
  const msgs = useRef(null);
  const {permissions} = useAppContext();
  //recebendo o objeto da tela anterior
  const location = useLocation();
  const commissionId =
    typeof location.state === "object"
      ? location.state.commissionId
      : location.state; // Extrai o número puro
  //states
  const [objectCommission, setObjectCommission] = useState({});
  const [loading, setLoading] = useState(null);
  const [selectedBrokers, setSelectedBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [calendarValue, setCalendarValue] = useState(new Date()); // Data inicial para Calendar
  const [calendarValues, setCalendarValues] = useState({});
  const [modalBrokers, setModalBrokers] = useState(false);
  const [totalBroker, setTotalBroker] = useState(0);
  const [totalImob, setTotalImob] = useState(0);
  const [totalBrokerImob, setTotalBrokerImob] = useState(0);
  const [isOutOfStandard, setIsOutOfStandard] = useState(false);
  const [messageDisplayed, setMessageDisplayed] = useState(false);
  const [radioButton, setRadioButton] = useState("1");
  const [initialCalculatedValue, setInitialCalculatedValue] = useState(0);
  const getCommission = async (id) => {
    try {
      setLoading(true);
      const response = await getCommissionsById(id); // Chamada para obter a comissão
      setObjectCommission(response);
      // console.log("response", response);
    } catch (error) {
      console.error("Erro ao buscar comissão:", error);
    }
    setLoading(false);
  };
  //header
  const items = [
    {
      template: () => (
        <Link to={"/financial/launchCommission"} className="p-breadcrumb-link">
          Comissões
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={"/financial/launchCommission"} className="p-breadcrumb-link">
          Lançamento de Comissões
        </Link>
      ),
    },
  ];
  //header
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };
  //modal de add corretores
  const closeModal = () => {
    setModalBrokers(false);
  };
 
  //watching values
  const watchQuantityInstallmentImob = form.watch("quantity_installment_imob");
  //armazenando as datas unicas de cada parcela
  const handleDateChange = (index, value) => {
    setCalendarValues((prev) => ({
      ...prev,
      [index]: value, // Armazena a data de acordo com o índice do corretor
    }));
  };
  
  //toda mudança de corretores, essa função será chamada para atualizar os valores da imob
  const updateImobPercentage = () => {
    const totalPorcBrokers = selectedBrokers.reduce((total, broker) => {
      return total + (broker.percentage || 0);
    }, 0);

    // Porcentagem restante para a imobiliária
    const remainingImobPercentage = Math.max(100 - totalPorcBrokers, 0);
    const remainingImobValue =
      (remainingImobPercentage * objectCommission.commission?.value) / 100;
    // Atualiza o valor no formulário
    form.setValue("porc_installment_imob", remainingImobPercentage); // Garante que não fique negativo
    form.setValue("value_installment_imob", remainingImobValue);
  };
  const addBroker = (broker) => {
    if (broker && !selectedBrokers.some((b) => b.id === broker.id)) {
      setSelectedBrokers((prev) => [...prev, broker]);
    }
    //toda vez que add atualiza a porcentagem da imob
    updateImobPercentage();
  };
  const removeBroker = (brokerId) => {
    const updatedBrokers = selectedBrokers.filter(
      (broker) => broker.id !== brokerId
    );
    setSelectedBrokers(updatedBrokers);
    //toda vez que retira atualiza a porcentagem da imob
    updateImobPercentage();
  };
  //mapeando o objeto de corretores para listar no select
  const brokers = objectCommission.commission?.commissionUsers;
  const brokerOptions = brokers
    ?.filter(
      (broker) =>
        broker.user_id !== objectCommission.commission?.real_estate_id && // Remove a imobiliária
        broker.user_id !== objectCommission.commission?.broker_id
    ) // Remove a imobiliária
    .map((broker) => ({
      value: broker.user_id, // ID do corretor
      label: broker.name, // Nome do corretor
      isDisabled: broker.user_id === objectCommission.commission?.broker_id, // Desabilita o corretor já atribuído
      percentage: broker.percentage || 0,
    }));

  const handleSaveBroker = () => {
    if (selectedBroker) {
      // Encontrar o broker selecionado em brokerOptions para garantir que tenha `percentage`
      const broker = brokerOptions.find((b) => b.value === selectedBroker);
      if (broker) {
        addBroker({
          id: broker.value, // ID do corretor
          name: broker.label, // Nome do corretor
          percentage: broker.percentage || 0, // Porcentagem com valor padrão de 5
        });
        setModalBrokers(false);
      } else {
        console.error("Broker não encontrado nos options!");
      }
    }
  };
  //MENSAGEM AVISO DO SAIR DO PADRAO
  // Valores padrão, para reiniciar os valores
  const defaultValues = {
    porc_installment_imob: objectCommission?.commission?.percentage || 0,
    value_installment_imob: 0,
    quantity_installment_imob: 1,
  };
  // Função para redefinir os valores ao padrão
  const resetToDefault = () => {
    form.reset({
      ...defaultValues,
      value_installment_imob: initialCalculatedValue, // Usa o valor calculado inicial salvo la no setInitialCalculatedValue
    });
    setSelectedBrokers([]); //limpando os corretores
    setIsOutOfStandard(false); // Define o estado como "dentro do padrão"
    setMessageDisplayed(false); // Reseta o controle da mensagem
    msgs.current.clear(); // Remove mensagens ativas
  };
  //modal aprovar comissao
  const approveProposal = () => {
    confirmDialog({
      message: "Deseja realmente aprovar esta proposta?",
      header: "Aprovar Proposta",
      icon: "pi pi-check-circle",
      acceptLabel: "Sim",
      rejectLabel: "Revisar",
      accept: () => {
        onSubmitComission(); // Função que executa a lógica de aprovação
      },
      reject: () => {
        console.log("Ação de aprovação cancelada");
      },
    });
  };
  const onSubmitComission = async () => {
    const data = form.getValues();
    const allCommissionUsers = objectCommission?.commission?.commissionUsers || [];

    const selectedBrokersMap = new Map(
      selectedBrokers.map((broker, index) => {
        const quantityInstallments = data[`quantity_installment_broker_${index}`];
        const valueInstallment = data[`value_installment_broker_${index}`];
        const initialDate = calendarValues[index]
          ? new Date(calendarValues[index])
          : new Date();
  
        return [
          broker.id,
          {
            user_id: broker.id,
            percentage: broker.percentage,
            installments: Array.from({ length: quantityInstallments }).map(
              (_, installmentIndex) => {
                const installmentDate = new Date(initialDate);
                installmentDate.setMonth(
                  installmentDate.getMonth() + installmentIndex
                );
  
                return {
                  value: valueInstallment,
                  date: installmentDate.toISOString().split("T")[0],
                  sequence_number: `${installmentIndex + 1}/${quantityInstallments}`,
                };
              }
            ),
          },
        ];
      })
    );
// Criando um array de usuários garantindo que todos estejam incluídos
const commissionUsers = allCommissionUsers.map((user) => {
  const selectedUser = selectedBrokersMap.get(user.user_id);

  return {
    user_id: user.user_id,
    percentage: selectedUser ? user.percentage : 0, // Se não estiver selecionado, zera a percentage
    ...(selectedUser && user.percentage !== 0 ? { installments: selectedUser.installments } : {}), 
    // Se não estiver selecionado ou percentage for 0, remove installments
  };
});


  
    // Dados da imobiliária
    const quantityInstallmentsImob = data["quantity_installment_imob"];
    const valueInstallmentImob = data["value_installment_imob"];
    const percentageImob = data["porc_installment_imob"];
    const real_state = {
      user_id: objectCommission?.commission?.real_estate_id,
      percentage: percentageImob,
      ...(percentageImob === 0 ? {} : {
        installments: Array.from({ length: quantityInstallmentsImob }).map(
          (_, installmentIndex) => {
            const installmentDate = calendarValue
              ? new Date(calendarValue)
              : new Date();
            installmentDate.setMonth(installmentDate.getMonth() + installmentIndex);
    
            return {
              value: valueInstallmentImob,
              date: installmentDate.toISOString().split("T")[0], // Formato "YYYY-MM-DD"
              sequence_number: `${installmentIndex + 1}/${quantityInstallmentsImob}`,
            };
          }
        ),
      }), // Se percentageImob for 0, não inclui installments
    };
    
    const finalCommissionUsers = [...commissionUsers]; 
const realEstateId = objectCommission?.commission?.real_estate_id
const existingUserIndex = finalCommissionUsers.findIndex(
  (user) => user.user_id === realEstateId
);

if (existingUserIndex !== -1) {
  const userToUpdate = finalCommissionUsers[existingUserIndex];

  userToUpdate.percentage += real_state.percentage;

  const brokerInstallments = userToUpdate.installments || [];
  const realEstateInstallments = real_state.installments || [];

  userToUpdate.installments = [
    ...brokerInstallments,
    ...realEstateInstallments,
  ];
  
} else {
  finalCommissionUsers.push(real_state);
}


// Controle do padrão
const is_default = isOutOfStandard ? 0 : 1;
  
  
    // Payload final
    const payload = {
      is_default,
      commissionUsers: finalCommissionUsers,
    };
    // console.log("payload", payload);
  
    const notification = toast.loading("Por favor aguarde...");
try {
  const response = await patchCommissionsGeral(commissionId, payload);
  
  if (response.success) {
    toast.update(notification, {
      render: response.success,
      autoClose: 5000,
      type: "success",
      isLoading: false,
    });

    navigate("/financial/launchCommission");
    closeModal();
  } else {
    toast.update(notification, {
      render: "Oops, algo deu errado. Tente novamente!",
      autoClose: 5000,
      type: "error",
      isLoading: false,
    });
  }
} catch (error) {
  console.error("Erro ao enviar comissão:", error);

  let errorMessage = "Erro ao enviar comissão. Tente novamente mais tarde.";

  // Verifica se a resposta do backend contém a chave "error"
  if (error.response) {
    errorMessage =
      error.response.data?.error || // Caso o erro esteja em error.response.data.error
      error.response.data?.message || // Caso o erro esteja em error.response.data.message
      JSON.stringify(error.response.data) || // Caso o erro seja um objeto
      errorMessage;
  } else if (error.message) {
    errorMessage = error.message;
  }

  toast.update(notification, {
    render: errorMessage,
    autoClose: 5000,
    type: "error",
    isLoading: false,
  });
}

  };
  
  //modal recusar comissao
  const rejectProposal = () => {
    confirmDialog({
      message: "Tem certeza que deseja recusar esta proposta?",
      header: "Recusar Proposta",
      icon: "pi pi-times-circle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => {
        handleReject(); // Função que executa a lógica de recusa
      },
      reject: () => {
        console.log("Ação de recusa cancelada");
      },
    });
  };

  const handleReject = async () => {
    const notification = toast.loading("Por favor aguarde...");
    try {
      const payload = { status: 2 };

      const response = await patchCommissionsStatus(commissionId, payload);
     
      if (response.success) {
        toast.update(notification, {
          render: response.success,
          autoClose: 5000,
          type: "success",
          isLoading: false,
        });

      
        navigate("/financial/launchCommission");
        closeModal();
      } else {
        toast.update(notification, {
          render: "Oops, algo deu errado. Tente novamente!",
          autoClose: 5000,
          type: "error",
          isLoading: false,
        });
      }
    } catch (error) {
      toast.dismiss(notification);
      toast.error("Erro ao enviar comissão");
      console.error("Erro ao enviar comissão:", error);
    }
  };
  const resetToPending = async () => {
    const notification = toast.loading("Por favor aguarde...");
    try {
      const payload = { status: 0 };
      const response = await patchCommissionsStatus(commissionId, payload);
      if (response.success) {
        toast.update(notification, {
          render: response.success,
          autoClose: 5000,
          type: "success",
          isLoading: false,
        });
        navigate("/financial/launchCommission");
        closeModal();
      } else {
        toast.update(notification, {
          render: "Oops, algo deu errado. Tente novamente!",
          autoClose: 5000,
          type: "error",
          isLoading: false,
        });
      }
    } catch (error) {
      toast.dismiss(notification);
      toast.error("Erro ao enviar comissão");
      console.error("Erro ao enviar comissão:", error);
    }
  };
  // useEffect para buscar os dados ao montar o componente
  useEffect(() => {
    if (commissionId) {
      getCommission(commissionId);
    }
  }, [commissionId]);
  //SEÇÃO CALCULO IMOBILIARIA
  useEffect(() => {
    if (objectCommission) {
      // Calcula o valor da comissão geral
      const totalCommission = calcCommissionGeral(
        objectCommission?.commission?.percentage,
        objectCommission?.commission?.value_land
      );
      //porcentagem da imobliaria sem a porcentagem dos corretores (imob sempre pega 100% da comissao geral e vai subtraindo dos corretores)
      const percentageImob = calcPercentageImobWithoutBrokers(
        objectCommission?.commission?.commissionUsers?.find(
          (user) => user.user_id === objectCommission.commission.broker_id
        )?.percentage
      );
      // Calcula o valor sobre a porcentagem da imobiliaria sem a porcentagem dos corretores
      const valueCommissionImobWithoutBrokers = calcValueImobWithoutBrokers(
        totalCommission,
        percentageImob
      );
      //guardando o valor inicial calculado, pois ele sera usado para resetar o valor
      setInitialCalculatedValue(valueCommissionImobWithoutBrokers);
      // Quando mudar manualmente o valor do input da imobiliaria salva o valor
      const manualValueImob =
        form.watch(`value_installment_imob`) !== undefined
          ? form.watch(`value_installment_imob`)
          : valueCommissionImobWithoutBrokers;
      // Calcula o valor por parcela quando mudar manualmente
      const calculatedManualValue = handleMultipliesCommission(
        manualValueImob,
        watchQuantityInstallmentImob
      );
      //se valor mudar, faz o calculo do valor modificado
      if (form.watch(`value_installment_imob`) !== calculatedManualValue) {
        form.setValue("value_installment_imob", calculatedManualValue);
      }
    }
  }, [
    objectCommission, // Dados do objeto de venda
    watchQuantityInstallmentImob, // Observa mudanças na quantidade de parcelas
  ]);
  //SEÇÃO CALCULO CORRETAGEM
  useEffect(() => {
    const calculateAllBrokers = () => {
      // Calcula o valor total da comissão geral
      const totalCommission = calcCommissionGeral(
        objectCommission?.commission?.percentage,
        objectCommission?.commission?.value_land
      );

      // Itera sobre os corretores selecionados
      selectedBrokers.forEach((broker, index) => {
        const brokerPercentage = broker.percentage || 0;

        // Calcula o valor inicial para o corretor com base na porcentagem
        const initialBrokerValue = (totalCommission * brokerPercentage) / 100;
        // Captura o valor inserido pelo usuário no input ou usa o valor calculado
        const manualValueBroker =
          form.watch(`value_installment_broker_${index}`) !== undefined
            ? form.watch(`value_installment_broker_${index}`)
            : initialBrokerValue;
        // Captura o número de parcelas especificado para o corretor
        const quantityInstallments =
          form.watch(`quantity_installment_broker_${index}`) || 0;

        // Calcula o valor por parcela
        const installmentValue = handleMultipliesCommission(
          manualValueBroker,
          quantityInstallments
        );

        // Atualiza os valores no formulário
        form.setValue(`value_installment_broker_${index}`, installmentValue);
        form.setValue(
          `quantity_installment_broker_${index}`,
          quantityInstallments
        );
        form.setValue(`porc_installment_broker_${index}`, brokerPercentage);
      });
    };

    calculateAllBrokers();
  }, [
    selectedBrokers, // Atualiza ao adicionar ou remover corretores
  ]);
  //CALCULO DOS VALORES TOTAIS imob + brokers
  useEffect(() => {
    // Função para calcular o total dos corretores
    const calculateTotalBroker = () => {
      let total = 0;
      selectedBrokers.forEach((broker, index) => {
        const valuePerInstallment =
          form.watch(`value_installment_broker_${index}`) || 0;
        const quantityInstallments =
          form.watch(`quantity_installment_broker_${index}`) || 1;

        // Soma o valor total de todas as parcelas do corretor
        total += valuePerInstallment * quantityInstallments;
      });

      setTotalBroker(total); // Atualiza o total da corretagem
    };

    // Função para calcular o total da imobiliária
    const calculateTotalImob = () => {
      const valuePerInstallmentImob = form.watch("value_installment_imob") || 0;
      const quantityInstallmentsImob =
        form.watch("quantity_installment_imob") || 1;

      // Calcula o valor total da imobiliária
      setTotalImob(valuePerInstallmentImob * quantityInstallmentsImob);
    };

    // Calcula o total geral
    const calculateTotalBrokerImob = () => {
      setTotalBrokerImob(totalBroker + totalImob);
    };

    // Executa os cálculos
    calculateTotalBroker();
    calculateTotalImob();
    calculateTotalBrokerImob();
  }, [
    selectedBrokers, // Recalcula ao alterar corretores
    form.watch(), // Recalcula ao alterar qualquer input
    totalBroker,
    totalImob,
  ]);
  //ATUALIZANDO A PORCENTAGEM DA IMOB APOS ADD MAIS CORRETORES
  useEffect(() => {
    updateImobPercentage();
  }, [selectedBrokers]);
  //ATUALIZANDO O VALOR DA IMOB APOS ADD MAIS CORRETORES
  useEffect(() => {
    const updateImobValue = () => {
      // Calcula a comissão geral
      const totalCommission = calcCommissionGeral(
        objectCommission?.commission?.percentage,
        objectCommission?.commission?.value_land
      );

      const remainingPercentage = calcPercentageImobWithoutBrokers(
        objectCommission?.commission?.commissionUsers?.find(
          (user) => user.user_id === objectCommission.commission.broker_id
        )?.percentage
      );
      // Calcula o valor restante para a imobiliária com base nos corretores
      const calcRemainingCommission = (valueCommission) => {
        return (remainingPercentage * valueCommission) / 100;
      };

      const imobCommission = calcRemainingCommission(totalCommission);

      //Prioriza o valor manual da imobiliária ou usa o valor calculado
      const manualValueImob =
        form.watch("value_installment_imob") || imobCommission;

      //Recupera o número de parcelas (com fallback para 1)
      const quantityInstallments = form.watch("quantity_installment_imob") || 1;

      //Calcula o valor da parcela
      const installmentValue = manualValueImob / quantityInstallments;

      // atualiza o formulário apenas se os valores forem diferentes
      if (form.watch("value_installment_imob") !== installmentValue) {
        form.setValue("value_installment_imob", installmentValue);
      }

      // Garantir atualização da quantidade de parcelas no formulário
      if (form.watch("quantity_installment_imob") !== quantityInstallments) {
        form.setValue("quantity_installment_imob", quantityInstallments);
      }
    };
    updateImobValue();
  }, [
    form.watch("quantity_installment_imob"), // Quantidade de parcelas
  ]);
  // Adicionando automaticamente o corretor responsável da venda no objeto que lista os corretores nas tabela
  useEffect(() => {
    if (
      objectCommission.commission?.broker_id &&
      !selectedBrokers.some(
        (broker) => broker.id === objectCommission.commission?.broker_id
      )
    ) {
      // Adiciona o corretor completo ao estado
      setSelectedBrokers((prev) => [
        ...prev,
        {
          id: objectCommission.commission.broker_id,
          name: objectCommission.commission.broker, // Nome do corretor
          percentage:
            objectCommission?.commission?.commissionUsers?.find(
              (user) => user.user_id === objectCommission.commission?.broker_id
            )?.percentage || 0, // Porcentagem de comissão
        },
      ]);
    }
  }, [objectCommission, selectedBrokers]);
  // Monitora mudanças nos inputs para detectar alterações e voltar os valores ao padrão
  useEffect(() => {
    const subscription = form.watch((values) => {
      const isImobChanged =
        values.value_installment_imob !==
          defaultValues.value_installment_imob ||
        values.quantity_installment_imob !==
          defaultValues.quantity_installment_imob;

      if (isImobChanged && !messageDisplayed) {
        setIsOutOfStandard(true); // Define o estado como "fora do padrão"
        setMessageDisplayed(true); // Marca a mensagem como exibida
        msgs.current.show([
          {
            severity: "info",
            summary: "Info",
            detail: (
              <span>
                Você saiu do padrão de comissão.{" "}
                <a
                  href="#"
                  className="text-black"
                  onClick={(e) => {
                    e.preventDefault();
                    resetToDefault();
                    setMessageDisplayed(false); // Permite exibir novamente após redefinir
                  }}
                >
                  Voltar ao padrão
                </a>
              </span>
            ),
            sticky: true,
            closable: false,
          },
        ]);
      }

      if (!isImobChanged) {
        setIsOutOfStandard(false); // Define o estado como "dentro do padrão"
        setMessageDisplayed(false); // Reseta o controle da mensagem
      }
    });

    // Limpa a assinatura ao desmontar o componente
    return () => subscription.unsubscribe();
  }, [form, defaultValues, messageDisplayed]);
  //setando o valor da data de hoje no inputs de broker
  useEffect(() => {
    if (!brokers || !Array.isArray(brokers)) return; // Verifica se brokers está definido
  
    setCalendarValues((prev) => {
      return brokers.reduce((acc, broker, index) => {
        acc[index] = prev?.[index] || new Date(); // Se não houver data, define como a atual
        return acc;
      }, {});
    });
  }, [brokers]);
  return (
    <div className="row d-flex justify-content-center">
      {loading ? (
        <div className="row">
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-12">
            <Skeleton width="100%" height={150} />
          </div>
          <div className="row justify-content-end">
            <div className="col-md-3 pt-3">
              <Skeleton width="100%" height={45} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="col-md-4">
            <BreadCrumb
              model={items}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>
          <div className="col-md-8 text-end">
  {objectCommission?.commission?.status === 0 ? (
    <>
      {permissions?.includes("182") && (
        <Button
          label="Recusar"
          severity="danger"
          icon={"fa-solid fa-xmark"}
          onClick={rejectProposal}
          iconPos="left"
          className="mx-2"
        />
      )}
      {permissions?.includes("182") && (
        <Button
          label="Aprovar"
          onClick={approveProposal}
          icon={"fa-solid fa-check"}
          iconPos="right"
        />
      )}
    </>
  ) : objectCommission?.commission?.status === 2 && permissions?.includes("182") ? (
    <Button
      label="Voltar para Pendente"
      severity="warning"
      icon={"fa-solid fa-rotate-left"}
      onClick={resetToPending}
      iconPos="left"
    />
  ) : null}
</div>



          <div className="invoice">
            <div className="invoice-company">
              {objectCommission?.commission?.enterprise || "Carregando..."} |{" "}
              Quadra {objectCommission?.commission?.land || "Carregando..."}{" "}
              Lote {objectCommission?.commission?.block || "Carregando..."}
            </div>
            <div className="invoice-header">
              <div className="invoice-from">
                <small>Cliente</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.client || "Carregando..."}
                  </strong>
                  <br />
                  CPF:
                  {objectCommission?.commission?.client_doc || "Carregando..."}
                  <br />
                </address>
              </div>
              <div className="invoice-to">
                <small>Corretor Selecionado</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.broker || "Carregando..."}
                  </strong>
                  <br />
                  Email:{" "}
                  {objectCommission?.commission?.broker_email ||
                    "Carregando..."}
                  <br />
                </address>
              </div>
              <div className="invoice-to">
                <small>Imobiliária Selecionada</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.real_estate ||
                      "Carregando..."}
                  </strong>
                </address>
              </div>
              <div className="invoice-date">
                <small>Data da Venda</small>
                <div className="date text-dark mt-5px">
                  {objectCommission?.commission?.created_at
                    ? formatDate(objectCommission?.commission?.created_at)
                    : "Carregando..."}
                </div>
                <div>
                  Valor do Lote:{" "}
                  {objectCommission?.commission?.value_land
                    ? formatCurrency(objectCommission?.commission?.value_land)
                    : "Carregando..."}
                </div>
              </div>
            </div>
            <Messages ref={msgs} />
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="invoice-company">
                  Porcentagem Geral de Comissão{" "}
                  {objectCommission?.commission?.percentage || "Carregando..."}%
                  -{" "}
                  {formatCurrency(
                    calcCommissionGeral(
                      objectCommission?.commission?.percentage,
                      objectCommission?.commission?.value_land
                    )
                  )}{" "}
                  <Tooltip
                    target=".custom-target"
                    position="top"
                    className=""
                  />
                  <i
                    className=" custom-target pi pi-question-circle p-text-secondary"
                    data-pr-tooltip="Este valor representa a porcentagem definida nas Configurações do Empreendimento e é calculado sobre o valor total do lote."
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
              </div>
            </div>
            <div className="invoice-company">
              IMOBILIÁRIA{" "}
              <Tooltip target=".custom-target" position="top" className="" />
              <i
                className="custom-target pi pi-question-circle p-text-secondary"
                data-pr-tooltip="À medida que corretores são adicionados, a porcentagem de comissão da imobiliária é proporcionalmente reduzida."
                style={{ cursor: "pointer" }}
              ></i>
            </div>
            <div className="invoice-content">
              <div className="table-responsive">
                <form onSubmit={form.handleSubmit(onSubmitComission)}>
                  <table className="table table-invoice">
                    <thead>
                      <tr>
                        <th className="text-start">IMOBILIÁRIA</th>
                        <th className="text-start">PORCENTAGEM DE COMISSÃO <Tooltip
                                                                  target=".custom-target"
                                                                  position="top"
                                                                  className=""
                                                                />
                                                                <i
                                                                  className=" custom-target pi pi-question-circle p-text-secondary"
                                                                  data-pr-tooltip="A imobiliária começa com 100% da comissão, mas essa porcentagem pode ser reduzida conforme as comissões dos corretores são distribuídas."
                                                                  style={{ cursor: "pointer" }}
                                                                ></i></th>
                        <th className="text-start">VALOR DA PARCELA</th>
                        <th className="text-start">QUANTIDADE PARCELAS</th>
                        <th className="text-end" width="20%">
                          VENCIMENTO 1ª PARCELA
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="align-middle">
                          <span className="text-dark">
                            {objectCommission?.commission?.real_estate ||
                              "Carregando..."}
                          </span>
                        </td>
                        <td className="align-middle">
                          <NumberInput
                            style={{ border: "solid red 1px" }}
                            name={`porc_installment_imob`}
                            suffix={radioButton === "1" && "%"}
                            placeholder={radioButton === "1" ? "0%" : "0"}
                            max={100}
                            control={form.control}
                            errors={errors}
                            disabled
                          />
                        </td>
                        <td className="align-middle">
                          <NumberInput
                            name={`value_installment_imob`}
                            control={form.control}
                            errors={errors}
                            min={0}
                            useGrouping={true}
                            locale="pt-BR"
                            placeholder="R$ 0,00"
                            prefix="R$"
                          />
                        </td>
                        <td className="align-middle">
                          <NumberInput
                            name={`quantity_installment_imob`}
                            control={form.control}
                            errors={errors}
                            mode="decimal"
                            min={1}
                            max={100}
                            useGrouping={false}
                          />
                        </td>
                        <td className="align-middle">
                          <Calendar
                            style={{ marginTop: "20px" }}
                            value={calendarValue}
                            onChange={(e) => setCalendarValue(e.value)}
                            dateFormat="dd/mm/yy"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="invoice-company">
                  CORRETOR{" "}
                  <Tooltip
                    target=".custom-target"
                    position="top"
                    className=""
                  />
                  <i
                    className="custom-target pi pi-question-circle p-text-secondary"
                    data-pr-tooltip="É possível adicionar mais corretores da equipe responsável pela venda, sendo que as comissões dos corretores serão subtraídas proporcionalmente do valor destinado à imobiliária."
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
              </div>
              <div className="col-md-6 text-end">
                <Button
                  label={"Adicionar outros corretores"}
                  icon="pi pi-plus"
                  onClick={() => setModalBrokers(true)}
                  className=""
                />
              </div>
            </div>
            <div className="invoice-content">
              <div className="table-responsive">
                <form onSubmit={form.handleSubmit(onSubmitComission)}>
                  <table className="table table-invoice">
                    <thead>
                      <tr>
                        <th className="text-start">CORRETOR</th>
                        <th className="text-start">COMISSÃO DO CORRETOR <Tooltip
                                                                  target=".custom-target"
                                                                  position="top"
                                                                  className=""
                                                                />
                                                                <i
                                                                  className=" custom-target pi pi-question-circle p-text-secondary"
                                                                  data-pr-tooltip="Essa é a porcentagem dos corretores definidas em Times"
                                                                  style={{ cursor: "pointer" }}
                                                                ></i></th>
                        <th className="text-start">VALOR DA PARCELA</th>
                        <th className="text-start">QUANTIDADE PARCELAS</th>
                        <th className="text-end" width="20%">
                          VENCIMENTO 1ª PARCELA
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedBrokers.map((broker, index) => (
                        <tr key={broker.id}>
                          <td className="align-middle">
                            <span className="text-dark">{broker.name}</span>
                          </td>
                          <td className="align-middle">
                            <NumberInput
                              name={`porc_installment_broker_${index}`}
                              control={form.control}
                              errors={errors}
                              disabled
                              value={broker.percentage}
                              suffix="%"
                            />
                          </td>
                          <td className="align-middle">
                            <NumberInput
                              name={`value_installment_broker_${index}`}
                              control={form.control}
                              errors={errors}
                              mode="currency"
                              currency="BRL"
                              min={0}
                              useGrouping={true}
                              locale="pt-BR"
                              placeholder="R$ 0,00"
                            />
                          </td>
                          <td className="align-middle">
                            <NumberInput
                              name={`quantity_installment_broker_${index}`}
                              control={form.control}
                              errors={errors}
                              mode="decimal"
                              min={1}
                              max={100}
                              useGrouping={false}
                              style={{ border: "solid red 1px" }}
                            />
                          </td>
                          <td className="align-middle">
                            <Calendar
                              style={{
                                marginTop: "20px",
                              }}
                              value={calendarValues[index] || null} // Usar a data correspondente ao corretor
                              onChange={(e) => handleDateChange(index, e.value)}
                              dateFormat="dd/mm/yy"
                            />
                          </td>
                          <td className="align-middle">
                            {broker.id !==
                              objectCommission.commission.broker_id && (
                              <Button
                                label="Remover"
                                icon="pi pi-trash"
                                severity="danger"
                                onClick={() => removeBroker(broker.id)}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
            <div className="invoice-price">
              <div className="invoice-price-left">
                <div className="invoice-price-row">
                  <div className="sub-price">
                    <small>COMISSÃO CORRETAGEM</small>
                    <span className="text-dark" name="total_broker">
                      <p name="total_broker">{formatCurrency(totalBroker)}</p>{" "}
                    </span>
                  </div>
                  <div className="sub-price">
                    <i className="fa fa-plus text-muted"></i>
                  </div>

                  <div className="sub-price">
                    <small>COMISSÃO IMOBILIÁRIA</small>
                    <span className="text-dark" name="total_imob">
                      <p name="total_broker">{formatCurrency(totalImob)}</p>{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="invoice-price-right">
                <small>Total</small>{" "}
                <span className="fw-bold">
                  <p name="total_broker">{formatCurrency(totalBrokerImob)}</p>{" "}
                </span>
              </div>
            </div>
          </div>
          <Modal
            visible={modalBrokers}
            dynamicTitle={"Adicione mais corretores para dividir a comissão"}
            onHide={closeModal}
            closable={true}
          >
            <div className="d-flex flex-column gap-3">
              {" "}
              <Select
                value={selectedBroker} // Sempre vazio para permitir múltiplas seleções
                onChange={(e) => {
                  setSelectedBroker(e); // Atualiza o estado
                }}
                name="broker"
                label="Selecione um Corretor"
                isRequired
                control={form.control}
                options={brokerOptions} // Opções formatadas dos corretores
                errors={errors}
              />
              <Button
                rounded
                type="button"
                label="Salvar"
                icon="fa fa-check"
                className="p-inputtext-sm"
                style={{
                  width: "150px", // Ajusta a largura do botão
                  alignSelf: "flex-end", // Alinha o botão à direita
                }}
                onClick={() => {
                  handleSaveBroker();
                }}
              />
            </div>
          </Modal>
        </>
      )}
    </div>
  );
}
